import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import {FaEnvelope} from 'react-icons/fa'
import axios from "axios"
import * as qs from "query-string"
import { useMediaQuery } from 'react-responsive'

const Form = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;

  .feedback {
    width: 50%;
    padding: 10px 10px;
    border-radius: 5px;
    margin-bottom: 20px;
  };

  .sent {
    background-color: #e6ffe2;
    border: 1px solid #97E08B;
  };

  .error {
    background-color: #ffe2e2;
    border: 1px solid #f4b0b0;
  }

  .control {
    margin: 10px 0px 25px 0px;
  }

  .input, .textarea {
    font-weight: 400;
  }
`

const ContactForm = (props) => {
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1025px)' });
  const [messageFeedback, setMessageFeedback] = useState('');
  const [messageStatus, setMessageStatus] = useState('');

  function handleSubmit(e) {
    e.preventDefault();
    e.persist();

    const formData = {
      "form-name": 'Contact Form',
      "name": e.target[2].value,
      "email": e.target[3].value,
      "subject": e.target[4].value,
      "message": e.target[5].value
    };
    // Object.keys(this.refs).map(key => (formData[key] = this.refs[key].value))
    
    const axiosOptions = {
      url: '/contact/',
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: qs.stringify(formData),
    }

    axios(axiosOptions)
      .then(response => {
        setMessageFeedback("Message has been sent, thank you!");
        setMessageStatus('sent');
        document.querySelector('#contact-form').reset();
      })
      .catch(err => {
        setMessageFeedback("There was a problem :( Please check your message and try again.");
        setMessageStatus('failed')
      })
  }

  return(
    <Form>
      {messageFeedback && 
      <span className={messageStatus === 'sent' ? 'feedback sent' : 'feedback error'}
            style={{width: (isTabletOrMobile ? '90%' : '60%')}}>
              {messageFeedback}
      </span>}
      <form onSubmit={e => handleSubmit(e)} id='contact-form' method="post" 
            name="Contact Form" netlify-honeypot="bot-field" data-netlify="true"
            style={{width: (isTabletOrMobile ? '90%' : '60%')}}>
        <input type="hidden" name="bot-field" />
        <input type="hidden" name="form-name" value="Contact Form" />
        <div className="field">
          <label className="label is-medium" for="name">
            Name
            <div className="control" name='name'>
              <input className="input is-medium" type="text" placeholder="Name" name="name" />
            </div>
          </label>
        </div>

        <div className="field">
          <label className="label is-medium" htmlFor="email">
            Email
            <div className="control has-icons-left has-icons-right">
              <input className="input is-medium" type="email" placeholder="Email" name="email" />
              <span className="icon is-small is-left">
                <FaEnvelope />
              </span>
            </div>
          </label>
        </div>
        <div className="field">
          <label className="label is-medium" htmlFor="subject">
            Subject
            <div className="control">
              <input className="input is-medium" type="text" placeholder="Subject" name="subject"/>
            </div>
          </label>
        </div>
        <div className="field">
          <label className="label is-medium" htmlFor="message">
            Message
            <div className="control">
              <textarea className="textarea is-medium" placeholder="Message" name="message"></textarea>
            </div>
          </label>
        </div>
        <div className="control">
          <button className="button is-primary">Submit</button>
        </div>
        </form>
      </Form>
  )
}

export default ContactForm